
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/direct-debit-request-service-agreement",
      function () {
        return require("private-next-pages/direct-debit-request-service-agreement/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/direct-debit-request-service-agreement"])
      });
    }
  